module.exports = __webpack_public_path__ + "static/media/tablets1.836f7c1f.png";